import React from 'react';
import VoteheadForm from '../components/VoteheadForm';

const VoteheadManagement = () => {
  return (
    <VoteheadForm />
  );
};

export default VoteheadManagement;
